'use client';

import { WidgetFallback } from '../../components/WidgetFallback';

/**
 * Route-level error boundary for every embeddable widget (events, markets,
 * indices). Without this, any thrown error in a server render or a client
 * chart blanks the iframe on the third-party site. Renders a neutral fallback
 * instead.
 */
export default function ExternalWidgetError() {
    return <WidgetFallback />;
}
